import { createAsyncThunk } from "@reduxjs/toolkit";
import { MovimentacaoBancariaModel } from "../models/relatorio/MovimentacaoBancariaModel";
import api from "../util/api";
import { ContaPagamentoRecebimentoModel } from "../models/relatorio/ContaPagamentoRecebimentoModel";
import { BuscarLancamentoBancarioModel } from "../models/lancamentoBancario/buscarLancamentoBancarioModel";
import { BuscaRelatorioContaBancariaModel } from "../models/relatorio/BuscaRelatorioContaBancariaModel";
import { BuscarRelatorioCreditosConsignatarioModel } from "../models/relatorio/buscarRelatorioCreditosConsignatarioModel";
import { BuscarRelatorioLancamentoFinanceiroModel } from "../models/relatorio/buscarRelatorioLancamentoFinanceiroModel";
import { BuscarRelatorioLancamentoFinanceiroDrillModel } from "../models/relatorio/buscarRelatorioLancamentoFinanceiroDrillModel";
import { BuscarRelatorioLancamentoFinanceiroPorMesDrillModel } from "../models/relatorio/buscarRelatorioLancamentoFinanceiroPorMesDrillModel";
import { BuscarRelatorioConsolidadoSaldoBancarioModel } from "../models/relatorio/buscarRelatorioConsolidadoSaldoBancarioModel";
import { setLoading } from "../redux/slices/configuracoes/configuracoesSlice";

export const gerarRelatorioContaFinanceira = createAsyncThunk("Relatorio/GerarRelatorioContaFinanceira", async (args: ContaPagamentoRecebimentoModel) => {
  try {
    const data = await api.post("Relatorio/GerarRelatorioContaFinanceira", args);
    return data.data.data;
  } catch (error: any) {
    throw new Error(error.response.data.Message);
  }
});

export const gerarRelatorioContaBancaria = createAsyncThunk("Relatorio/GerarRelatorioContaBancaria", async (args: BuscaRelatorioContaBancariaModel) => {
  try {
    const data = await api.post("Relatorio/GerarRelatorioContaBancaria", args);
    return data.data.data;
  } catch (error: any) {
    throw new Error(error.response.data.Message);
  }
});

export const gerarRelatorioMovimentacaoBancaria = createAsyncThunk("/Relatorio/GerarRelatorioMovimentacaoFinanceira", async (args: MovimentacaoBancariaModel) => {
  try {
    const data = await api.get("/Relatorio/GerarRelatorioMovimentacaoFinanceira", {
      params: args,
    });
    return data.data.data;
  } catch (error: any) {
    throw new Error(error.response.data.Message);
  }
});

export const gerarRelatorioLancamentoBancario = createAsyncThunk("/Relatorio/GerarRelatorioLancamentoBancario", async (args: BuscarLancamentoBancarioModel, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    const data = await api.post("/Relatorio/GerarRelatorioLancamentoBancario", args);
    dispatch(setLoading(false));
    return data.data.data;
  } catch (error: any) {
    dispatch(setLoading(false));

    throw new Error(error.response.data.Message);
  }
});

export const gerarRelatorioCreditosConsignatario = createAsyncThunk("/Relatorio/GerarRelatorioCreditosConsignatario", async (args: BuscarRelatorioCreditosConsignatarioModel) => {
  try {
    const data = await api.get("/Relatorio/GerarRelatorioCreditosConsignatario", {
      params: args,
    });
    return data.data.data;
  } catch (error: any) {
    throw new Error(error.response.data.Message);
  }
});

export const buscarRelatorioLancamentoFinanceiro = createAsyncThunk("Relatorio/BuscarRelatorioLancamentoFinanceiro", async (args: BuscarRelatorioLancamentoFinanceiroModel) => {
  try {
    const data = await api.post("Relatorio/BuscarRelatorioLancamentoFinanceiro", args);
    return data.data.data;
  } catch (error: any) {
    throw new Error(error.response.data.Message);
  }
});

export const buscarRelatorioLancamentoFinanceiroDrill = createAsyncThunk("Relatorio/BuscarRelatorioLancamentoFinanceiroDrill", async (args: BuscarRelatorioLancamentoFinanceiroDrillModel) => {
  try {
    const data = await api.post("Relatorio/BuscarRelatorioLancamentoFinanceiroDrill", args);
    return data.data.data;
  } catch (error: any) {
    throw new Error(error.response.data.Message);
  }
});

export const buscarRelatorioLancamentoFinanceiroPorMes = createAsyncThunk("Relatorio/BuscarRelatorioLancamentoFinanceiroPorMes", async (args: BuscarRelatorioLancamentoFinanceiroModel) => {
  try {
    const data = await api.post("Relatorio/BuscarRelatorioLancamentoFinanceiroPorMes", args);
    return data.data.data;
  } catch (error: any) {
    throw new Error(error.response.data.Message);
  }
});

export const buscarRelatorioLancamentoFinanceiroPorMesDrill = createAsyncThunk(
  "Relatorio/BuscarRelatorioLancamentoFinanceiroPorMesDrill",
  async (args: BuscarRelatorioLancamentoFinanceiroPorMesDrillModel) => {
    try {
      const data = await api.post("Relatorio/BuscarRelatorioLancamentoFinanceiroPorMesDrill", args);
      return data.data.data;
    } catch (error: any) {
      throw new Error(error.response.data.Message);
    }
  }
);

export const gerarRelatorioConsolidadoSaldoBancario = createAsyncThunk("Relatorio/GerarRelatorioConsolidadoSaldoBancario", async (args: BuscarRelatorioConsolidadoSaldoBancarioModel) => {
  try {
    const data = await api.post("Relatorio/GerarRelatorioConsolidadoSaldoBancario", args);
    return data.data.data;
  } catch (error: any) {
    throw new Error(error.response.data.Message);
  }
});

export const gerarRelatorioConsolidadoSaldoBancarioDetalhe = createAsyncThunk("Relatorio/GerarRelatorioConsolidadoSaldoBancarioDetalhe", async (args: BuscarRelatorioConsolidadoSaldoBancarioModel) => {
  try {
    const data = await api.post("Relatorio/GerarRelatorioConsolidadoSaldoBancarioDetalhe", args);
    return data.data.data;
  } catch (error: any) {
    throw new Error(error.response.data.Message);
  }
});

export const gerarRelatorioConsolidadoSaldoBancarioResumo = createAsyncThunk("Relatorio/GerarRelatorioConsolidadoSaldoBancarioResumo", async (args: BuscarRelatorioConsolidadoSaldoBancarioModel) => {
  try {
    const data = await api.post("Relatorio/GerarRelatorioConsolidadoSaldoBancarioResumo", args);
    return data.data.data;
  } catch (error: any) {
    throw new Error(error.response.data.Message);
  }
});
